// lib
import React, { useContext, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/question-views/xq/Component'

// components
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'

// styles
import style from '@aytm/app/stats/page/question-views/xq/styles/ScriptItem.module.scss'

const ScriptItemSelect = ({ item, value, multiple }) => {
  const { model, disabled, onChange } = useContext(DataContext)

  const itemOptions = useMemo(
    () => item.options.map(r => (r instanceof Object ? { key: r.value, text: r.text } : { key: r, text: r })),
    [item.options]
  )

  const onValueChange = useCallback(
    option => {
      const options = Array.isArray(option)
        ? option.map(r => (r instanceof Object ? r.value : r))
        : option instanceof Object
        ? option.value
        : option

      if (value != options) {
        model.args[item.id] = options
        onChange(model)
      }
    },
    [item.id, value, model, onChange]
  )

  return (
    <div className={`${style.item} p-fluid`}>
      {disabled ? (
        <div
          className="p-field p-col-12"
          dangerouslySetInnerHTML={{ __html: Array.isArray(value) ? value.join(', ') : value }}
        />
      ) : (
        <>
          <div
            className={`${style['item-title']} p-field p-col-4`}
            dangerouslySetInnerHTML={{ __html: item.text || item.id }}
          />
          <div className={`p-field p-col-8`}>
            {multiple ? (
              <MultiSelect
                placeholder="Select..."
                value={value}
                options={itemOptions}
                optionValue="key"
                optionLabel="text"
                maxSelectedLabels={1}
                showSelectAll={false}
                fixedDropdownDir="bottom"
                onChange={event => onValueChange(event.value)}
              />
            ) : (
              <Dropdown
                placeholder="Select..."
                value={value}
                options={itemOptions}
                optionValue="key"
                optionLabel="text"
                fixedDropdownDir="bottom"
                onChange={event => onValueChange(event.value)}
              />
            )}
          </div>
        </>
      )}
    </div>
  )
}

ScriptItemSelect.propTypes = {
  item: PropTypes.object,
  value: PropTypes.any,
  multiple: PropTypes.bool
}

ScriptItemSelect.displayName = 'ScriptItemSelect'

export default ScriptItemSelect
